export const NORMAL = "NORMAL";
export const START = "START";
export const END = "END";
export const WALL = "WALL";
export const PATH = "PATH";